var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcitivityIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.85527,
    y: 1.85527,
    width: 33.7105,
    height: 33.7105,
    rx: 7.21241,
    fill: "#EAE7FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.85527,
    y: 1.85527,
    width: 33.7105,
    height: 33.7105,
    rx: 7.21241,
    stroke: "#F8F7FE",
    strokeWidth: 3.71054
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22866_22281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.92431 23.2226C10.1445 25.2808 11.7998 26.936 13.8569 27.1653C15.3848 27.3356 16.9536 27.4819 18.5531 27.4819C20.1525 27.4819 21.7213 27.3356 23.2492 27.1653C25.3064 26.936 26.9616 25.2808 27.1818 23.2226C27.3444 21.7034 27.4816 20.1435 27.4816 18.5533C27.4816 16.9631 27.3444 15.4033 27.1818 13.884C26.9616 11.8259 25.3064 10.1706 23.2492 9.94134C21.7213 9.77103 20.1525 9.62476 18.5531 9.62476C16.9536 9.62476 15.3848 9.77103 13.8569 9.94134C11.7998 10.1706 10.1445 11.8259 9.92431 13.884C9.76176 15.4033 9.6245 16.9631 9.6245 18.5533C9.6245 20.1435 9.76176 21.7034 9.92431 23.2226Z",
    fill: "#E0D6F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.92431 23.2226C10.1445 25.2808 11.7998 26.936 13.8569 27.1653C15.3848 27.3356 16.9536 27.4819 18.5531 27.4819C20.1525 27.4819 21.7213 27.3356 23.2492 27.1653C25.3064 26.936 26.9616 25.2808 27.1818 23.2226C27.3444 21.7034 27.4816 20.1435 27.4816 18.5533C27.4816 16.9631 27.3444 15.4033 27.1818 13.884C26.9616 11.8259 25.3064 10.1706 23.2492 9.94134C21.7213 9.77103 20.1525 9.62476 18.5531 9.62476C16.9536 9.62476 15.3848 9.77103 13.8569 9.94134C11.7998 10.1706 10.1445 11.8259 9.92431 13.884C9.76176 15.4033 9.6245 16.9631 9.6245 18.5533C9.6245 20.1435 9.76176 21.7034 9.92431 23.2226Z",
    stroke: "#715DE3",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8532 18.3262C23.8532 18.3262 21.9912 17.7992 21.4641 18.3262C20.9371 18.8533 20.4198 21.7726 19.5713 21.7726C18.7227 21.7726 18.1528 15.3341 17.5351 15.3341C16.6865 15.3341 16.1693 18.2535 15.6422 18.7805C15.1152 19.3076 13.2531 18.7805 13.2531 18.7805",
    stroke: "#715DE3",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22866_22281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8.55307 8.55331)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcitivityIcon);
export default __webpack_public_path__ + "static/media/acitivity_icon.3209ad4ca99efff334d5cc3bf610781d.svg";
export { ForwardRef as ReactComponent };